import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Avatar2 } from "../assets/svg/Avatar2";
import { TitleText } from "../ui/Text";
import { CloseIcon2 } from "../assets/svg/CloseIcon2";
import { get } from "../utils/get";

interface IProps {
  isClosable?: boolean;
  data?: any;
  setSelected?: any;
  isPreSelected?: boolean;
  setModalOpen?: any;
  style?: any;
}

export const AttendeeCard = ({
  isClosable = false,
  data,
  setSelected,
  isPreSelected,
  style,
  setModalOpen,
}: IProps) => {
  const [activeItem, setActiveItem] = useState(!!isPreSelected);

  const names = `${get(data, "first_name", "")} ${get(data, "last_name", "")}`;

  useEffect(() => {
    // console.log(activeItem, "attendee");
  },[isPreSelected,activeItem])

  return (
    <Container
      onClick={() => {
        setSelected && setSelected(!activeItem);
        setSelected && setActiveItem(!activeItem);
        if (setModalOpen) {
          setModalOpen(false);
        }
      }}
      selected={activeItem}
      style={{ ...style }}
    >
      <ImageItem
        src={
          get(data, "avatar_url") ||
          `https://ui-avatars.com/api/?name=${get(data, "names")
          ? get(data, "names", names)
          : get(data, "owner_names")
          ? get(data, "owner_names")
          : get(data, "name")}`
        }
        // alt=""
      />
      <TitleText>
        {get(data, "names")
          ? get(data, "names", names)
          : get(data, "owner_names")
          ? get(data, "owner_names")
          : get(data, "name")}
      </TitleText>
      <span>
        {isClosable && (
          <CloseIcon2
            onClick={() => {
              setSelected && setSelected(false);
            }}
          />
        )}
      </span>
    </Container>
  );
};

const Container = styled.span<{ selected: boolean }>`
  display: flex;
  flex-direction: row;
  /* grid-template-columns: 2em auto 2em; */
  align-items: center;
  align-content: center;
  background-color: ${(props) => (props.selected ? "#EBEFFF" : "#f5f6fb")};
  height: 3em;
  border-radius: 0.5em;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  ${TitleText} {
    color: ${(props) => (props.selected ? "#01A8CE" : "")};
  }
  span {
    margin-left: auto;
    padding-right: 1em;
  }
`;
const ImageItem = styled.img`
  margin: 0px 10px;
  /* border: 2px solid #ffffff; */
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  /* padding: 1em; */
  /* box-shadow: 0px 5px 20px rgba(22, 51, 198, 0.15); */
`;
